import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import WorkerHeader from "../../worker-header/components";
import WorkerFooter from "../../worker-footer/components";
import { getAllPlans } from "../slice/workerAllPlansSlice";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

const WorkerAllPlans = () => {
  const dispatch = useDispatch();

  const { workerAllPlansData } = useSelector(
    (state) => state.workerAllPlansSlice
  );

  const token = localStorage.getItem("token");
  const [loadingPlanId, setLoadingPlanId] = useState(null);

  useEffect(() => {
    if (token) {
      dispatch(getAllPlans(token));
    }
  }, [token, dispatch]);
  const handlePlanPayment = async (payload) => {
    try {
      setLoadingPlanId(payload.plan_id);
      const res = await fetch(`${BACKEND_URL}/checkout-session`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        console.error("Backend error:", data);
        setLoadingPlanId(null);
        return;
      }

      if (data?.data?.url) {
        window.location.href = data.data.url;
      }
    } catch (err) {
      setLoadingPlanId(null);
      console.error("Stripe Checkout error:", err);
    }
  };

  return (
    <>
      <WorkerHeader />

      <section className="home-banner position-relative">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="hero-section row align-items-center" style={{ background: "#012c47" }}>
                    {/* Left Column */}
                    <div className="col-lg-7 col-xl-7" >
                      <div className="homebanner text-center text-lg-start">
                        <h1 className="montserrat font-weight-bold lh-1">
                          <p className="d-lg-block font-size-36 mb-0">Membership Plans</p>
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

      <section className="homepad" id="drive">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="position-relative">
                    <img src="/assets/images/about-img.jpg" alt="..." className="w-100 about-img" />
                  </div>
                </div>
                <div className="col-lg-6 font-size-16 font-weight-normal line-hight-3 text-muted mt-4 mt-lg-0 pt-3 pt-lg-0">
                  <div className="ps-lg-4 ps-xl-5">
                    <div>
                      <div className="bg-primary-heading-main font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4">
                        <span className="bg-yellow d-inline-block p-1 bg-primary-heading-main rounded-pill favicon-logo01 text-center me-2">
                          <img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" />
                        </span>
                        What Drives Us
                      </div>
                    </div>
                  
                   
                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Early Identification:
                      </strong>
                      <br />
                      <span>
                        Research shows that the earlier we identify speech, behavioral, or developmental needs, the better the outcomes. That’s why we focus on early screening, support, and referrals during the most critical years of a child’s development.
                      </span>
                    </p>
                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Empowered Families and Providers:
                      </strong>
                      <br />
                      <span>
                        We unite parents, caregivers, teachers, and medical professionals through our platform, providing AI-guided tools, training resources, and licensed providers to ensure no one falls through the cracks.
                      </span>
                    </p>
                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Equity, Access, and Innovation:
                      </strong>
                      <br />
                      <span>
                        Every child—regardless of zip code, language, or income—deserves a chance to thrive. Our platform ensures access to culturally responsive tools, Medicaid/Medicare-integrated services, and a growing provider network tailored to local needs.
                      </span>
                    </p>

                    <div className="mt-5">
                      <div className="bg-primary-heading-main font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4">
                        <span className="bg-yellow d-inline-block p-1 bg-primary-heading-main rounded-pill favicon-logo01 text-center me-2">
                          <img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" />
                        </span>
                        How We Work
                      </div>
                    </div>
                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Technology-Driven Solutions:
                      </strong>
                      <br />
                      <span>
                        Our AI tools help screen and match children with the right providers and services.
                      </span>
                    </p>
                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Real-Time Support:
                      </strong>
                      <br />
                      <span>
                        We offer virtual consults, on-demand educational webinars, and resource kits for both parents and professionals.
                      </span>
                    </p>
                    <p className="mt-3">
                      <strong>
                        <span className="me-2 text-primary">✔</span> Provided Provider Network:
                      </strong>
                      <br />
                      <span>
                        Every provider in our system is vetted, licensed, and aligned with best practices in early intervention.
                      </span>
                    </p>


                  </div>
                  
                </div>
                

                
              </div>
            </div>
          </section>

      {workerAllPlansData.length === 0 ? (
        <div className="text-center py-5">
          <h5 className="text-muted">No Plan Available</h5>
        </div>
      ) : (
        <div className="container mb-5">
          <div className="membership-plans">
            {workerAllPlansData.map((plan) => (
              <div className="plan-card active" key={plan.id}>
                <div className="plan-header">
                  <h3 className="plan-title">{plan.name}</h3>
                </div>

                <div className="plan-price">
                  <strong>${plan.price} / month</strong>
                </div>

                <div className="plan-description">
                  <ul>
                    <li>{plan.description}</li>
                  </ul>
                </div>

                <div className="plan-footer">
                  <button
                    className="plan-button outline"
                    disabled={loadingPlanId === plan.id}
                    onClick={() =>
                      handlePlanPayment({
                        plan_id: plan.id,
                      })
                    }
                  >
                    {loadingPlanId === plan.id ? (
                      <span className="spinner-border spinner-border-sm me-2"></span>
                    ) : null}

                    {loadingPlanId === plan.id ? "Redirecting..." : "Pay"}
                  </button>

                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <WorkerFooter />
    </>
  );
};

export default WorkerAllPlans;
